module.exports = __webpack_public_path__ + "img/gsxw_4.714e757a.png";